import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VTextField } from 'vuetify/lib/components/VTextField';
import ClickOutside from 'vuetify/lib/directives/click-outside';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VNavigationDrawer, {
    directives: [{
      def: ClickOutside,
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDrawer,
      expression: "clickOutsideDrawer"
    }],
    attrs: {
      fixed: "",
      bottom: "",
      right: "",
      width: _vm.drawerWidth,
      temporary: ""
    },
    model: {
      value: _vm.drawer,
      callback: function callback($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c("div", {
    staticClass: "drawer"
  }, [_c("section", {
    staticClass: "drawer-header"
  }, [_c("div", {
    staticClass: "drawer-title"
  }, [_c(VBtn, {
    staticClass: "primary",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.close
    }
  }, [_c(VIcon, {
    attrs: {
      dark: ""
    }
  }, [_vm._v("mdi-close")])], 1), _c("h2", [_vm._v("Split " + _vm._s(_vm.order.reference_order.shorterReference()))])], 1)]), _c(VStepper, {
    key: _vm.steps.length,
    attrs: {
      vertical: ""
    },
    model: {
      value: _vm.currentStep,
      callback: function callback($$v) {
        _vm.currentStep = $$v;
      },
      expression: "currentStep"
    }
  }, [_vm._l(_vm.steps, function (step) {
    return [_c("div", {
      key: "step_".concat(step.id)
    }, [_c(VStepperStep, {
      attrs: {
        step: step.id,
        complete: _vm.currentStep > step.id,
        rules: step.rules,
        editable: ""
      }
    }, [_vm._v(" " + _vm._s(step.title) + " "), _c("small", [_vm._v(_vm._s(step.inf))])]), step.key === "items" ? _c(VStepperContent, {
      staticClass: "pt-0",
      attrs: {
        step: step.id
      }
    }, [_c("div", {
      staticClass: "text-left"
    }, [_c("div", [_vm.itemsShown.length === 0 ? _c("div", {
      staticClass: "text-smaller text-italic mt-2"
    }, [_vm._v(" No item chosen, or no match ")]) : _c("div", {
      staticClass: "items-list"
    }, [_c("div", {
      staticClass: "flex"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2",
      on: {
        click: function click($event) {
          return _vm.pickAllItems();
        }
      }
    }, [_c(VIcon, {
      staticClass: "fas fa-clipboard-check mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Pick all order ")], 1), _c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      on: {
        click: function click($event) {
          return _vm.unpickAllItems();
        }
      }
    }, [_c(VIcon, {
      staticClass: "fas fa-clipboard-check mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Unpick all order ")], 1)], 1), _vm._l(_vm.itemsShown, function (item, i) {
      var _item$item_provenance;
      return _c("div", {
        key: "filterItem-".concat(i),
        class: ["item-row", item.isInNewOrder ? "item-chosen" : ""],
        attrs: {
          id: "filterItem-".concat(i)
        }
      }, [_c("div", {
        staticClass: "item-fast-action mr-2 mt-1"
      }, [item.isInNewOrder ? _c(VIcon, {
        staticClass: "fa fa-trash icon-link",
        attrs: {
          small: ""
        },
        on: {
          click: function click($event) {
            return _vm.changeQuantityNewOrder(item, 0);
          }
        }
      }) : _c(VIcon, {
        staticClass: "fa fa-plus icon-link",
        attrs: {
          small: ""
        },
        on: {
          click: function click($event) {
            _vm.changeQuantityNewOrder(item, item.quantity / item.casingId.match(/\d+/)[0]);
          }
        }
      })], 1), _c("div", {
        staticClass: "item-row-quantity flex --bottom"
      }, [_c(VTextField, {
        key: _vm.quantityToggleKey,
        staticClass: "ma-0 pa-0 text-center",
        attrs: {
          type: "number",
          "hide-details": "auto",
          value: item.isInNewOrder ? _vm.form.newOrderItems.find(function (x) {
            return x.fromItemId == item.id_item;
          }).nbBottles / _vm.form.newOrderItems.find(function (x) {
            return x.fromItemId == item.id_item;
          }).originalItem.casingId.match(/\d+/)[0] : 0,
          min: 0,
          max: item.quantity / item.casingId.match(/\d+/)[0]
        },
        on: {
          change: function change($event) {
            return _vm.changeQuantityNewOrder(item, $event);
          },
          keypress: _vm.filterIntegerKey
        }
      }), _c("div", {
        staticClass: "text-nowrap"
      }, [_vm._v(" / " + _vm._s(item.quantity / item.casingId.match(/\d+/)[0]) + " c. ")])], 1), _c("div", {
        staticClass: "item-row-informations ml-4"
      }, [_c("div", {
        staticClass: "item-row-winename"
      }, [_vm._v(" " + _vm._s(_vm.wineNaming(_vm.$whitelabel, item.wine.naming_data, true, true, true)) + " " + _vm._s(item.wine.sku) + " ")]), _c("div", {
        staticClass: "flex --baseline --space-between"
      }, [_c("div", [_c("div", {
        staticClass: "item-row-casing"
      }, [_vm._v(" " + _vm._s(_vm.casingWines.find(function (x) {
        return x.value === item.casingId;
      }).text) + " ")]), _c("div", {
        staticClass: "item-row-provenance"
      }, [item.isDirectWinery ? [_vm._v(" From winery, " + _vm._s(item.wine.sku) + ", " + _vm._s(_vm.computeAddressStockConsignment(item)) + " ")] : [_vm._v(" From " + _vm._s(item.warehouseName) + ", " + _vm._s(item.wine.sku) + " ")], (_item$item_provenance = item.item_provenances) !== null && _item$item_provenance !== void 0 && _item$item_provenance.some(function (ip) {
        return ip.stockPart.status === _vm.STOCK_PART.STATUS.PRESELL.id;
      }) ? _c("span", {
        staticClass: "badge warning --small --padding ml-1"
      }, [_vm._v(" #PRE-ARRIVAL ")]) : _vm._e()], 2)]), _vm.isSourcingAvailable ? _c("div", {
        staticClass: "flex --column --bottom"
      }, [_c("div", {
        staticClass: "item-row-status"
      }, [item.isDirectWinery ? _c("div", [item.associatedPurchaseOrders.length > 0 ? _c("i", {
        staticClass: "fas fa-arrow-alt-circle-down sourcing-icon",
        class: _vm.getItemPoStatus(item)
      }) : [_c("i", {
        staticClass: "fas fa-arrow-alt-circle-down sourcing-icon danger"
      }), _c("span", {
        staticClass: "ml-1"
      }, [_vm._v("No PO associated")])]], 2) : _vm._e()]), item.isDirectWinery && item.associatedPurchaseOrders.length ? _c("div", {
        staticClass: "item-row-sourcing-infos"
      }, _vm._l(item.associatedPurchaseOrders, function (po) {
        return _c("div", {
          key: "po-".concat(po.id),
          staticClass: "info-row"
        }, [_vm.isItemPoWarning(po, item.quantity) || _vm.isItemPoDanger(po) ? _c("i", {
          staticClass: "fas fa-hourglass-half sourcing-icon danger"
        }) : _vm._e(), _vm.isItemPoSuccess(po, item.quantity) ? _c("i", {
          staticClass: "fas fa-check sourcing-icon success"
        }) : _vm._e(), _c("span", {
          staticClass: "info-row-quantity"
        }, [_vm._v(" " + _vm._s(po.quantity) + " b. / " + _vm._s(item.quantity) + " b. ")]), _c("span", [_vm._v("#" + _vm._s(po.number))])]);
      }), 0) : _vm._e()]) : _vm._e()])])]);
    })], 2)]), _c("div", [_c(VTextField, {
      attrs: {
        placeholder: "Search for a product in existing order",
        clearable: "",
        "hide-details": "auto",
        "append-icon": "fa-search"
      },
      on: {
        keyup: function keyup($event) {
          return _vm.itemsSearch();
        },
        "click:clear": function clickClear() {
          ;
          _vm.itemsSearchLabel = null, _vm.itemsSearch();
        }
      },
      model: {
        value: _vm.itemsSearchLabel,
        callback: function callback($$v) {
          _vm.itemsSearchLabel = $$v;
        },
        expression: "itemsSearchLabel"
      }
    }), _c(VCheckbox, {
      staticClass: "mt-2",
      attrs: {
        label: "Show items from winery",
        "hide-details": "auto"
      },
      on: {
        change: function change($event) {
          return _vm.itemsSearch();
        }
      },
      model: {
        value: _vm.itemsSearchFromWinery,
        callback: function callback($$v) {
          _vm.itemsSearchFromWinery = $$v;
        },
        expression: "itemsSearchFromWinery"
      }
    })], 1), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        disabled: !_vm.hasItemsChosen
      },
      on: {
        click: function click($event) {
          return _vm.confirmStep();
        }
      }
    }, [_vm._v(" Continue ")])], 1)])]) : _vm._e(), step.key === "mail" ? _c(VStepperContent, {
      key: "splitDrawerMail_".concat(step.id),
      attrs: {
        step: step.id
      }
    }, [_c(VExpansionPanels, {
      on: {
        change: _vm.changePanel
      },
      model: {
        value: _vm.openedPanel,
        callback: function callback($$v) {
          _vm.openedPanel = $$v;
        },
        expression: "openedPanel"
      }
    }, _vm._l(_vm.form.emailTemplates, function (emailTemplate, i) {
      return _c(VExpansionPanel, {
        key: "splitDrawerExpansion-panel_".concat(i),
        attrs: {
          id: "splitDrawerExpansion-panel_".concat(i)
        }
      }, [_c(VExpansionPanelHeader, [_c(VBtn, {
        staticClass: "expansion-panel-header-close-btn",
        attrs: {
          icon: ""
        },
        on: {
          click: function click($event) {
            return _vm.deleteTemplatePanel(i);
          }
        }
      }, [_c(VIcon, [_vm._v("mdi-close")])], 1), _vm._v(" " + _vm._s(emailTemplate.name) + " ")], 1), _c(VExpansionPanelContent, [!_vm.flattenPlaceholders.length ? _c(VSkeletonLoader, {
        staticStyle: {
          width: "100%"
        },
        attrs: {
          type: "image"
        }
      }) : [_vm.isNeedingSync ? _c(VBtn, {
        staticClass: "sync-btn",
        attrs: {
          rounded: "",
          loading: _vm.isSyncing
        },
        on: {
          click: _vm.syncLatestVersion
        }
      }, [_c(VIcon, [_vm._v("mdi-lightning-bolt")]), _vm._v(" Sync latest version ")], 1) : _vm._e(), _vm.openedPanel === i ? _c("MailTemplateForm", {
        key: "splitDrawerStep_template_".concat(emailTemplate.id, "_").concat(i),
        attrs: {
          order: _vm.order,
          placeholders: _vm.emailPlaceholders,
          templates: _vm.emailTemplates,
          documents: _vm.documents,
          isDeletingTemplate: _vm.isDeletingTemplate
        },
        on: {
          edit: _vm.editTemplate,
          delete: _vm.deleteTemplate,
          change: _vm.changeTemplate,
          "click:new": _vm.newTemplate,
          "click:placeholder": _vm.clickPlaceholder
        },
        model: {
          value: _vm.form.emailTemplates[i],
          callback: function callback($$v) {
            _vm.$set(_vm.form.emailTemplates, i, $$v);
          },
          expression: "form.emailTemplates[i]"
        }
      }) : _vm._e()]], 2)], 1);
    }), 1), _c(VBtn, {
      staticClass: "new-email-btn",
      attrs: {
        rounded: ""
      },
      on: {
        click: _vm.newEmail
      }
    }, [_c(VIcon, [_vm._v("mdi-plus")]), _vm._v(" new e-mail ")], 1), _c(VDivider), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary"
      },
      on: {
        click: _vm.confirmStep
      }
    }, [_vm._v("Continue")])], 1)], 1) : _vm._e(), step.key === "synthesis" ? _c(VStepperContent, {
      attrs: {
        step: step.id
      }
    }, [_vm.isInvalidMainForm ? _c("div", {
      staticClass: "errorLabel text-sm"
    }, [_c("p", [_vm._v("Make sure you have completed all the previous step.")]), _vm._l(_vm.errorsMainForm, function (error, i) {
      return _c("div", {
        key: "mainError-".concat(i)
      }, [_vm._v(" " + _vm._s(error) + " ")]);
    })], 2) : _c("div", {
      staticClass: "text-left pb-2"
    }, [_c("div", {
      staticClass: "mt-4"
    }, [_c("span", {
      staticClass: "text-bold"
    }, [_vm._v(" Will not notify the customer by automatic platform mail ")])]), !!_vm.form.emailTemplates.length ? _c("div", {
      staticClass: "mt-8"
    }, [_c("i", {
      staticClass: "fas fa-envelope mr-1"
    }), _vm._v(" Email(s) "), _c("strong", [_vm._v("(x" + _vm._s(_vm.form.emailTemplates.length) + ")")]), _vm._l(_vm.form.emailTemplates, function (emailTemplate, i) {
      return _c("div", {
        key: "splitDrawerSynthesis_template_".concat(emailTemplate.id),
        staticClass: "text-sm"
      }, [_c(VDivider, {
        staticClass: "my-3"
      }), _c("div", {
        staticClass: "synthesis-email-line"
      }, [_c("div", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.isSuccessfulSending["".concat(emailTemplate.id, "_").concat(i)],
          expression: "isSuccessfulSending[`${emailTemplate.id}_${i}`]"
        }],
        staticClass: "sent-container"
      }, [_c("svg", {
        attrs: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 130.2 130.2"
        }
      }, [_c("circle", {
        staticClass: "path circle",
        attrs: {
          fill: "none",
          stroke: "#73AF55",
          "stroke-width": "6",
          "stroke-miterlimit": "10",
          cx: "65.1",
          cy: "65.1",
          r: "62.1"
        }
      }), _c("polyline", {
        staticClass: "path check",
        attrs: {
          fill: "none",
          stroke: "#73AF55",
          "stroke-width": "6",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          points: "100.2,40.2 51.5,88.8 29.8,67.5 "
        }
      })]), _vm._v(" Sent! ")]), _c("div", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.failedCustomMails["".concat(emailTemplate.id, "_").concat(i)],
          expression: "failedCustomMails[`${emailTemplate.id}_${i}`]"
        }],
        staticClass: "sent-container text-center"
      }, [_c("svg", {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          viewBox: "0 0 150.2 150.2"
        }
      }, [_c("path", {
        staticClass: "path",
        attrs: {
          d: "M 10,10 l 90,90 M 100,10 l -90,90",
          stroke: "red",
          "stroke-width": "10"
        }
      })]), _vm._v(" Not sent! ")]), _c("div", [_c("div", {
        staticClass: "mt-1"
      }, [_c("strong", [_vm._v(_vm._s(emailTemplate.name) + ":")])]), _c("div", {
        staticClass: "text-italic mb-1",
        staticStyle: {
          "font-size": "1rem"
        }
      }, [_vm._v(" " + _vm._s(emailTemplate.from) + " "), _c("i", {
        staticClass: "fas fa-paper-plane mx-2",
        staticStyle: {
          "font-size": "0.85rem"
        }
      }), _vm._v(" " + _vm._s(emailTemplate.sendTo && emailTemplate.sendTo.join(", ")) + " ")]), _c("div", {
        staticClass: "text-italic"
      }, _vm._l(emailTemplate.files, function (file) {
        return _c("a", {
          key: "file_".concat(file.id, "_").concat(file.name),
          staticClass: "mr-2",
          attrs: {
            href: !!file.blob ? file.url : _vm.URL.createObjectURL(file),
            target: "_blank"
          }
        }, [_c("i", {
          staticClass: "fas fa-paperclip"
        }), _vm._v(" " + _vm._s(file.id || file.name) + " ")]);
      }), 0)])])], 1);
    })], 2) : _c("div", {
      staticClass: "errorLabel mt-3"
    }, [_vm._v(" No custom mail has been configured. Are you sure to continue ? ")])]), _c(VExpandTransition, [_vm.hasFailedSending ? _c(VAlert, {
      staticClass: "--error my-2",
      attrs: {
        type: "error",
        outlined: "",
        dense: ""
      }
    }, [_vm._v(' Some custom emails were not sent! You must use the button "Send mail" on top of order details to resend them. ')]) : _vm._e()], 1), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        loading: _vm.isValidating,
        disabled: _vm.isInvalidMainForm || _vm.hasFailedSending
      },
      on: {
        click: _vm.validateMain
      }
    }, [_vm._v(" " + _vm._s(_vm.form.emailTemplates.length > 0 ? "Split & Send" : "Split order") + " ")])], 1)], 1) : _vm._e()], 1)];
  })], 2)], 1), _vm.templateModalShown ? _c("MailTemplateModal", {
    attrs: {
      shown: _vm.templateModalShown,
      placeholders: _vm.emailPlaceholders,
      template: _vm.editableTemplate
    },
    on: {
      save: _vm.saveTemplate,
      close: _vm.closeTemplateModal
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };